import { CustomCardColorBar, CustomPanel, PageHeader, PontuacaoCard } from '../../../../components'
import React from 'react'
import { azul, error, laranja, verde } from '../../../../assets/js/colors'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { withRouter } from 'react-router-dom'
import { tableCellCentered } from '../../../../assets/js/styles'

function EtapaApuracaoEntregas({ history }) {
  const etapaApuracaoEntregaInfo = history.location.state.etapa_apuracao_entrega_info

  const { pontuacao_total, pontuacao_obtida, tp_name, apuracao_entrega_info } =
    etapaApuracaoEntregaInfo

  // Helpers

  // Render
  return (
    <>
      <PageHeader>
        Status Operação - &nbsp; <strong>Etapa Apuração das Entregas dos Veículos</strong>
      </PageHeader>
      <div style={{ marginTop: 16 }}>
        <CustomPanel showBtnNovo={false} onVoltar={history.goBack}>
          <div className="p-grid">
            <div className="p-col-9">
              <h2>{tp_name}</h2>
            </div>
            <div className="p-col-3">
              <PontuacaoCard pontuacaoTotal={pontuacao_total} pontuacaoObtida={pontuacao_obtida} />
            </div>
            <div className="p-col-12">
              <ApuracaoEntregaInfo apuracaoEntregaInfo={apuracao_entrega_info} />
            </div>
          </div>
        </CustomPanel>
      </div>
    </>
  )
}

function ApuracaoEntregaInfo({ apuracaoEntregaInfo }) {
  const {
    qte_total_veiculos_nao_apurados,
    qte_veiculos_nao_apurados_2_dias,
    qte_veiculos_nao_apurados_entre_3_e_5_dias,
    qte_veiculos_nao_apurados_acima_5_dias,
    entregas_nao_apuradas,
  } = apuracaoEntregaInfo

  return (
    <div className="p-grid">
      <div className="p-col-12">
        <PageHeader>Veículos Pendentes para Apuração</PageHeader>
      </div>
      <div className="p-col-3">
        <CustomCardColorBar
          barColor={azul}
          value={qte_total_veiculos_nao_apurados}
          title={'Qte Veículos Não Apurados'}
          subTitle={'Total de Veículos não apurados'}
        />
      </div>
      <div className="p-col-3">
        <CustomCardColorBar
          barColor={verde}
          value={qte_veiculos_nao_apurados_2_dias}
          title={'Qte Veículos - 2 dias'}
          subTitle={'Saíram a 02 dias atrás'}
        />
      </div>
      <div className="p-col-3">
        <CustomCardColorBar
          barColor={laranja}
          value={qte_veiculos_nao_apurados_entre_3_e_5_dias}
          title={'Qte Veículos entre 3 e 5 dias'}
          subTitle={'Saíram entre 3 e 5 dias atrás'}
        />
      </div>
      <div className="p-col-3">
        <CustomCardColorBar
          barColor={error}
          value={qte_veiculos_nao_apurados_acima_5_dias}
          title={'Qte Veículos acima de 5 dias'}
          subTitle={'Saíram a mais de 5 dias atrás'}
        />
      </div>
      <div className="p-col-12">
        <DataTable value={entregas_nao_apuradas} emptyMessage={'Nenhum registro encontrado'}>
          <Column field={'empresa'} header={'Empresa'} />
          <Column
            field={'qte_total_entregas_nao_apuradas'}
            header={'TT. Entregas Não Apuradas'}
            style={tableCellCentered(200)}
          />
          <Column
            field={'qte_entregas_nao_apurados_2_dias'}
            header={'Entregas Não Apuradas até 2 dias'}
            style={tableCellCentered(200)}
          />
          <Column
            field={'qte_entregas_nao_apuradas_entre_3_e_5_dias'}
            header={'Entregas Não Apuradas entre 3 e 5 dias'}
            style={tableCellCentered(200)}
          />
          <Column
            field={'qte_entregas_nao_apuradas_acima_5_dias'}
            header={'Entregas Não Apuradas acima 5 dias'}
            style={tableCellCentered(200)}
          />
        </DataTable>
      </div>
    </div>
  )
}

export default withRouter(EtapaApuracaoEntregas)
